import { useContext } from 'react';

import { AuthContext } from '../context/AuthContext';

export const useAuth = () => {
  const value = useContext(AuthContext);

  return value;
};
